<template>
  <div>
    <!-- 修改楼盘展示 -->
    <div v-if="mode == 'edit'">
      <van-nav-bar
        :title="topTitle"
        :right-text="lang.previous"
        :left-arrow="!$route.query.fromapp"
        @click-right="prev"
        @click-left="prev"
      />
      <div class="tit">
        <span class="num">6</span>
        <span class="titname">{{ lang.adClass }}</span>
      </div>
      <van-button
        type="default"
        size="large"
        class="edit"
        :disabled="Buttondisable"
        @click="edit"
      >
        {{ lang.subEdit }}
      </van-button>
    </div>
    <!-- 复制楼盘 || 新增楼盘 -->
    <div
      v-if="mode == 'copy' || mode == 'post'"
      class="post"
    >
      <van-nav-bar
        :title="topTitle"
        :right-text="lang.previous"
        :left-arrow="!$route.query.fromapp"
        @click-right="prev"
        @click-left="prev"
      />
      <div class="tit">
        <span class="num">6</span>
        <span class="titname">{{ lang.adClass }}</span>
      </div>
      <div class="chooseGrop">
        <!-- 同意放盘守则 -->
        <div class="cell">
          <p>
            {{ lang.agreeCon }}<router-link to="/help?id=4">
              {{ lang.Conditions }}
            </router-link>
          </p>
          <van-switch
            v-model="agreeRule"
            active-color="#E40E2B"
            size="24px"
          />
        </div>
        <!-- 支付方式 -->
        <van-cell
          :title="lang.payway"
          :value="payText"
          is-link
          class="spacing"
          @click="paywayshow = true"
        />
        <van-popup
          v-if="coinHiden"
          v-model="paywayshow"
          position="top"
          :overlay="false"
          class="choose"
        >
          <van-nav-bar
            :title="lang.payway"
            left-arrow
            :right-text="lang.confirm"
            @click-left="paywayshow = false"
            @click-right="paywayshow = false"
          />
          <van-radio-group v-model="payway">
            <van-cell
              v-for="item in lang.NoCoinPayway"
              :key="item.value"
              :title="item.name"
              clickable
              @click="payway = item.value"
            >
              <van-radio
                :name="item.value"
                checked-color="#ED1818"
              />
            </van-cell>
          </van-radio-group>
        </van-popup>
        <van-popup
          v-else
          v-model="paywayshow"
          position="top"
          :overlay="false"
          class="choose"
        >
          <van-nav-bar
            :title="lang.payway"
            left-arrow
            :right-text="lang.confirm"
            @click-left="paywayshow = false"
            @click-right="paywayshow = false"
          />
          <van-radio-group v-model="payway">
            <van-cell
              v-for="item in lang.Dpayway"
              :key="item.value"
              :title="item.name"
              clickable
              @click="payway = item.value"
            >
              <van-radio
                :name="item.value"
                checked-color="#ED1818"
              />
            </van-cell>
          </van-radio-group>
        </van-popup>
        <!-- 放盘 普通  -->
        <div
          class="cell spacing bottom"
          @click="normal"
        >
          <div class="label">
            <h4>{{ lang.listingNorl }}</h4>
            <p v-if="url.indexOf('en-us') == -1">
              {{ lang.Generallisting1 }}；{{ lang.span }}{{ standard.effectiveDays }}{{ lang.ri }},{{ lang.zpan }}{{ standard.rentEffectiveDays }}{{ lang.ri }}
            </p>
            <p v-else>
              {{ lang.Generallisting1 }}：{{ standard.effectiveDays }} {{ lang.ri }}{{ lang.span1 }} {{ standard.rentEffectiveDays }} {{ lang.ri }}{{ lang.zpan1 }}
            </p>
            <div
              v-if="payway == 2"
              class="prices"
            >
              <del>{{ standard.propertyCoin }}</del> {{ standard.discountPropertyCoin }} {{ lang.GoldCoin }}
            </div>
            <div
              v-else
              class="prices"
            >
              HK$<del>{{ standard.price }}</del> {{ standard.discountPrice }}
            </div>
          </div>
          <div class="btn">
            <span :class="{ checked: PropertyInfo.topType == 'normal' || PropertyInfo.topType === 0 }" />
          </div>
        </div>
        <!-- 放盘 黄金-->
        <!-- <div class="cell bottom" @click="gold">
          <div class="label">
            <h4>{{ lang.listingGolt }}</h4>
            <p v-if="url.indexOf('en-us') == -1">{{ lang.Generallisting2 }}；{{ lang.szpan }}{{ Super.rentEffectiveDays }}{{ lang.ri }}</p>
            <p v-else>{{ lang.Generallisting2 }}：{{ Super.rentEffectiveDays }} {{ lang.szpan }}</p>
            <div class="prices" v-if="payway == 2">
              <del>{{ Super.propertyCoin }}</del> {{ Super.discountPropertyCoin }} {{ lang.GoldCoin }}
            </div>
            <div class="prices" v-else>
              HK$<del>{{ Super.price }}</del> {{ Super.discountPrice }}
            </div>
          </div>
          <div class="btn">
            <span :class="{ checked: PropertyInfo.topType == 'goldTop' || PropertyInfo.topType === 1 }"></span>
          </div>
        </div> -->
        <!-- 放盤-樓盤驗證標籤 -->
        <div class="cell bottom">
          <div class="label">
            <h5>{{ lang.verif }}</h5>
            <p>{{ lang.verifRemark }}</p>
            <div
              v-if="payway == 2"
              class="prices"
            >
              {{ Verified.discountPropertyCoin }} {{ lang.GoldCoin }}
            </div>
            <div
              v-else
              class="prices"
            >
              HK${{ Verified.discountPrice }}
            </div>
          </div>
          <van-switch
            v-model="PropertyInfo.isVerify"
            active-color="#E40E2B"
            size="24px"
          />
        </div>
        <!-- 提交证明 -->
        <van-cell
          v-if="PropertyInfo.isVerify"
          :title="lang.addressProof"
          is-link
          class="spacing"
          @click="$router.push('/addressCheck/')"
        />
      </div>
      <!-- 提交按钮 -->
      <div class="submit">
        <div class="moeny">
          <span>{{ lang.needMoeny }} ({{ payText }})</span>
          <p v-if="payway == 2">
            {{ PropertyInfo.topType == 'normal' ? NorlMoeny : GoldMoeny }} {{ lang.GoldCoin }}
          </p>
          <p v-else>
            ${{ PropertyInfo.topType == 'normal' ? NorlMoeny : GoldMoeny }}
          </p>
        </div>
        <button
          :class="{ red: submitInfo && !Buttondisable }"
          :disabled="Buttondisable"
          @click="postRule"
        >
          {{ lang.submit }}
        </button>
      </div>
      <!-- 确认放盘类型对话框  新增楼盘-->
      <van-dialog
        v-model="confrimTypeDialog"
        :title="lang.confrimType"
        show-cancel-button
        :confirm-button-text="lang.confirm"
        :cancel-button-text="lang.cancel"
        @confirm="AddProperty"
      >
        <div class="confirmType">
          {{ lang.confrimCate }}:
          {{ PropertyInfo.topType == 'normal' ? lang.listingNorl : lang.listingGolt }}
          {{ PropertyInfo.isVerify ? `、${lang.verif}` : '' }}<br>
          {{ lang.payway }}：{{ payText }}<br>
          {{ lang.confrimMoeny }}：
          <span v-if="payway == 2">{{ PropertyInfo.topType == 'normal' ? NorlMoeny : GoldMoeny }} {{ lang.GoldCoin }}</span>
          <span v-else>${{ PropertyInfo.topType == 'normal' ? NorlMoeny : GoldMoeny }}</span>
          <p>{{ lang.confrimtxt }}</p>
        </div>
      </van-dialog>
    </div>
    <!-- 立即付款 || 增加曝光率-->
    <div v-if="mode == 'paynow' || mode == 'renewal'">
      <van-nav-bar
        :title="topTitle"
        :left-arrow="!$route.query.fromapp"
        @click-left="prev"
      />
      <div class="tit">
        <span class="num">6</span>
        <span class="titname">{{ lang.adClass }}</span>
      </div>
      <!-- 放盘守则 -->
      <div
        v-if="mode == 'renewal'"
        class="cell"
      >
        <p>
          {{ lang.agreeCon }}<router-link to="/help?id=4">
            {{ lang.Conditions }}
          </router-link>
        </p>
        <van-switch
          v-model="agreeRule"
          active-color="#E40E2B"
          size="24px"
        />
      </div>
      <!-- 付款方式 -->
      <van-cell
        :title="lang.payway"
        :value="payText"
        is-link
        class="spacing"
        @click="paywayshow = true"
      />
      <van-popup
        v-if="coinHiden"
        v-model="paywayshow"
        position="top"
        :overlay="false"
        class="choose"
      >
        <van-nav-bar
          :title="lang.payway"
          left-arrow
          :right-text="lang.confirm"
          @click-left="paywayshow = false"
          @click-right="paywayshow = false"
        />
        <van-radio-group v-model="payway">
          <van-cell
            v-for="item in lang.NoCoinPayway"
            :key="item.value"
            :title="item.name"
            clickable
            @click="payway = item.value"
          >
            <van-radio
              :name="item.value"
              checked-color="#ED1818"
            />
          </van-cell>
        </van-radio-group>
      </van-popup>
      <van-popup
        v-else
        v-model="paywayshow"
        position="top"
        :overlay="false"
        class="choose"
      >
        <van-nav-bar
          :title="lang.payway"
          left-arrow
          :right-text="lang.confirm"
          @click-left="paywayshow = false"
          @click-right="paywayshow = false"
        />
        <van-radio-group v-model="payway">
          <van-cell
            v-for="item in lang.Dpayway"
            :key="item.value"
            :title="item.name"
            clickable
            @click="payway = item.value"
          >
            <van-radio
              :name="item.value"
              checked-color="#ED1818"
            />
          </van-cell>
        </van-radio-group>
      </van-popup>
      <!-- 放盘 普通  -->
      <div
        v-if="PropertyInfo.topType === 'normal'"
        class="cell spacing bottom"
        @click="normal"
      >
        <div class="label">
          <h4>{{ lang.listingNorl }}</h4>
          <p v-if="url.indexOf('en-us') == -1">
            {{ lang.Generallisting1 }}；{{ lang.span }}{{ standard.effectiveDays }}{{ lang.ri }},{{ lang.zpan }}{{ standard.rentEffectiveDays }}{{ lang.ri }}
          </p>
          <p v-else>
            {{ lang.Generallisting1 }}：{{ standard.effectiveDays }} {{ lang.ri }}{{ lang.span1 }} {{ standard.rentEffectiveDays }} {{ lang.ri }}{{ lang.zpan1 }}
          </p>
          <div v-if="priceHidden">
            <div
              v-if="payway == 2"
              class="prices"
            >
              <del>{{ standard.propertyCoin }}</del>{{ standard.discountPropertyCoin }} {{ lang.GoldCoin }}
            </div>
            <div
              v-else
              class="prices"
            >
              HK$<del>{{ standard.price }}</del> {{ standard.discountPrice }}
            </div>
          </div>
        </div>
        <div class="btn">
          <span :class="[{ checked: PropertyInfo.topType == 'normal' }, 'disable']" />
        </div>
      </div>
      <!-- 放盘 黄金-->
      <!-- <div class="cell spacing bottom" @click="gold" v-if="PropertyInfo.topType === 'goldTop'">
        <div class="label">
          <h4>{{ lang.listingGolt }}</h4>
          <p v-if="url.indexOf('en-us') == -1">{{ lang.Generallisting2 }}；{{ lang.szpan }}{{ Super.rentEffectiveDays }}{{ lang.ri }}</p>
          <p v-else>{{ lang.Generallisting2 }}：{{ Super.rentEffectiveDays }} {{ lang.szpan }}</p>
          <div v-if="priceHidden">
            <div class="prices" v-if="payway == 2">
              <del>{{ Super.propertyCoin }}</del> {{ Super.discountPropertyCoin }} {{ lang.GoldCoin }}
            </div>
            <div class="prices" v-else>
              HK$<del>{{ Super.price }}</del> {{ Super.discountPrice }}
            </div>
          </div>
        </div>
        <div class="btn">
          <span :class="[{ checked: PropertyInfo.topType == 'goldTop' }, 'disable']"></span>
        </div>
      </div> -->
      <!-- 放盤-樓盤驗證標籤 -->
      <div
        v-if="mode == 'paynow' && PropertyInfo.isVerify"
        class="cell bottom"
      >
        <div class="label">
          <h5>{{ lang.verif }}</h5>
          <p>{{ lang.verifRemark }}</p>
          <div v-if="priceHidden">
            <div
              v-if="payway == 2"
              class="prices"
            >
              {{ Verified.discountPropertyCoin }} {{ lang.GoldCoin }}
            </div>
            <div
              v-else
              class="prices"
            >
              HK${{ Verified.discountPrice }}
            </div>
          </div>
        </div>
        <van-switch
          v-model="PropertyInfo.isVerify"
          active-color="#E40E2B"
          disabled
          size="24px"
        />
      </div>
      <div v-if="mode == 'renewal'">
        <div class="cell bottom">
          <div class="label">
            <h5>{{ lang.verif }}</h5>
            <p>{{ lang.verifRemark }}</p>
            <div v-if="priceHidden">
              <div
                v-if="payway == 2"
                class="prices"
              >
                {{ Verified.discountPropertyCoin }} {{ lang.GoldCoin }}
              </div>
              <div
                v-else
                class="prices"
              >
                HK${{ Verified.discountPrice }}
              </div>
            </div>
          </div>
          <van-switch
            v-model="PropertyInfo.isVerify"
            active-color="#E40E2B"
            :disabled="lastVerify"
            size="24px"
          />
        </div>
        <van-cell
          v-if="PropertyInfo.isVerify && !lastVerify"
          :title="lang.addressProof"
          is-link
          class="spacing"
          @click="$router.push('/addressCheck/')"
        />
      </div>
      <!-- 续费或者增加曝光率按钮 -->
      <div
        v-if="mode == 'renewal'"
        class="submit"
      >
        <div class="moeny">
          <span>{{ lang.needMoeny }} ({{ payText }})</span>
          <p v-if="payway == 2">
            {{ PropertyInfo.topType == 'normal' ? NorlMoeny : GoldMoeny }} {{ lang.GoldCoin }}
          </p>
          <p v-else>
            ${{ PropertyInfo.topType == 'normal' ? NorlMoeny : GoldMoeny }}
          </p>
        </div>
        <button
          :class="{ red: submitInfo }"
          @click="SubmitVerif() ? (confrimUpDialog = true) : ''"
        >
          {{ lang.submit }}
        </button>
      </div>
      <!-- 提交放盤按钮 -->
      <div
        v-else
        class="submit"
      >
        <div class="moeny">
          <span>{{ lang.needMoeny }} ({{ payText }})</span>
          <div v-if="priceHidden">
            <p v-if="payway == 2">
              {{ PropertyInfo.topType == 'normal' ? NorlMoeny : GoldMoeny }} {{ lang.GoldCoin }}
            </p>
            <p v-else>
              ${{ PropertyInfo.topType == 'normal' ? NorlMoeny : GoldMoeny }}
            </p>
          </div>
          <div v-if="!priceHidden">
            <p v-if="payway == 2">
              {{ payInfo.money }} {{ lang.GoldCoin }}
            </p>
            <p v-else>
              ${{ payInfo.money }}
            </p>
          </div>
        </div>
        <button
          class="red"
          @click="nowpayDialog = true"
        >
          {{ lang.submit }}
        </button>
      </div>
      <!-- 确认放盘类型对话框  续费或者增加曝光率按钮-->
      <van-dialog
        v-if="mode == 'renewal'"
        v-model="confrimUpDialog"
        :title="lang.confrimType"
        show-cancel-button
        :confirm-button-text="lang.confirm"
        :cancel-button-text="lang.cancel"
        @confirm="AddLight()"
      >
        <div class="confirmType">
          {{ lang.confrimCate }}:
          {{ PropertyInfo.topType == 'normal' ? lang.listingNorl : lang.listingGolt }}
          {{ PropertyInfo.isVerify ? `、${lang.verif}` : '' }}<br>
          {{ lang.payway }}：{{ payText }}<br>
          {{ lang.confrimMoeny }}：
          <span v-if="payway == 2">{{ PropertyInfo.topType == 'normal' ? NorlMoeny : GoldMoeny }} {{ lang.GoldCoin }}</span>
          <span v-else>${{ PropertyInfo.topType == 'normal' ? NorlMoeny : GoldMoeny }}</span>
          <p>{{ lang.confrimtxt }}</p>
        </div>
      </van-dialog>
      <!-- 立即付款对话框 -->
      <van-dialog
        v-else
        v-model="nowpayDialog"
        :title="lang.confrimType"
        show-cancel-button
        :confirm-button-text="lang.confirm"
        :cancel-button-text="lang.cancel"
        @confirm="payNow"
      >
        <div class="confirmType">
          {{ lang.confrimCate }}:
          {{ PropertyInfo.topType == 'normal' ? lang.listingNorl : lang.listingGolt }}
          {{ PropertyInfo.isVerify ? `、${lang.verif}` : '' }} <br>
          {{ lang.payway }}：{{ payText }} <br>
          {{ lang.confrimMoeny }}：
          <span v-if="priceHidden">
            <span v-if="payway == 2">{{ PropertyInfo.topType == 'normal' ? NorlMoeny : GoldMoeny }} {{ lang.GoldCoin }}</span>
            <span v-else>${{ PropertyInfo.topType == 'normal' ? NorlMoeny : GoldMoeny }}</span>
          </span>
          <span v-if="!priceHidden">
            <span v-if="payway == 2">{{ payInfo.money }} {{ lang.GoldCoin }}</span>
            <span v-else>${{ payInfo.money }}</span>
          </span>
          <p>{{ lang.confrimtxt }}</p>
        </div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant';
import { mapState, mapMutations } from 'vuex';
import lang from './../../../common/language/post';
import post from './../../../common/js/post';
export default {
  name: 'Step6',
  data() {
    return {
      lang,
      url: document.URL,
      query: '',
      Buttondisable: false, //禁止提交按钮
      payText: 'PayPal',
      payway: '1',
      topTitle: '',
      confrimTypeDialog: false, // 新增楼盘
      nowpayDialog: false, // 立即付款对话跨
      confrimUpDialog: false, // 确认曝光对话框
      agreeRule: false, // 同意规则
      paywayshow: false,
      paysuccess: true,
      standard: {},
      Super: {},
      Verified: {},
      propertyID: 0, // 楼盘id
      orderID: 0, // 订单id
      payInfo: [], //支付信息
      priceHidden: true, //隐藏价格
      PropertyInfo: {
        topType: 'normal', // 是置顶盘源
        isVerify: false, //放盤-樓盤驗證標籤
        verifyImage: []
      },
      postInfo: '',
      lastVerify: '',
      mode: '',
      coinHiden: false,
      version: ''
    };
  },
  watch: {
    payway(val, old) {
      this.lang.Dpayway.forEach(ele => {
        if (ele.value == val) {
          this.payText = ele.name;
        }
      });
    },
    $route(val, old) {
      if (val.query.type == 1) {
        this.getOrder();
        this.topTitle = post.getTitle(this, this.lang);
        this.propertyID = this.propertyInfo.propertyID;
      }
    }
  },
  created() {
    this.version = this.$route.query.version ? `${this.$route.query.version}` : '';
    if (this.version) {
      this.pub.getAppConfig(this.version).then(res => {
        this.coinHiden = res; // true 隐藏金币支付
      });
    }
    this.topTitle = post.getTitle(this, this.lang);
    this.getState();
    this.setPath(this.$route.fullPath);
    post.getQuery(this);
    if (this.mode == 'paynow') {
      this.propertyID = this.propertyInfo.propertyID;
      this.getOrder();
    }
    if (this.mode == 'renewal' || this.mode == 'paynow') {
      /**续期的时候要判断物业编号是否未填写 或者填写了中文*/
      if (this.propertyInfo.propertySource === 2) {
        if (this.propertyInfo.propertyNo === null || !this.propertyInfo.propertyNo.trim()) {
          Dialog({ message: lang.require5.adspropertyNumber, confirmButtonText: lang.confirm }).then(() => {
            this.$router.go(-1);
          });
          return;
        }
        if (/.*[\u4e00-\u9fa5]+.*$/.test(this.propertyInfo.propertyNo)) {
          Dialog({ message: lang.require5.adspropertyNumErr, confirmButtonText: lang.confirm }).then(() => {
            this.$router.go(-1);
          });
          return;
        }
      }
      if (this.propertyInfo.lastVerify !== undefined) {
        this.lastVerify = this.propertyInfo.lastVerify;
      } else {
        this.lastVerify = this.propertyInfo.isVerify;
      }
    }
    if (this.$route.query.success == 1) {
      if (this.mode == 'paynow') {
        this.paySuccess(lang.payDone);
      }
      if (this.mode == 'renewal') {
        this.paySuccess(lang.payAdd);
      } else {
        this.paySuccess(lang.payDone);
      }
    }
  },
  methods: {
    ...mapMutations(['setProperty', 'stepChange', 'clearAll', 'setType', 'setBasePrice', 'setPath']),
    //  搜索房源服务价格
    SearchPropertyPriceSet() {
      this.axios.get(this.pub.getApi().SearchPropertyPriceSet).then(res => {
        if (res.data.code === 0) {
          this.setBasePrice(res.data.result);
          this.standard = this.basePrice[0];
          this.Super = this.basePrice[1];
          this.Verified = this.basePrice[2];
        }
      });
    },
    getState() {
      this.PropertyInfo.isVerify = this.propertyInfo.isVerify;
      this.PropertyInfo.verifyImage = this.propertyInfo.verifyImage;
      if (this.propertyInfo.agreeRule) {
        this.agreeRule = this.propertyInfo.agreeRule;
      }
      if (this.propertyInfo.payway) {
        this.payway = this.propertyInfo.payway;
      }
      if (this.propertyInfo.topType == 0 || this.propertyInfo.topType == 'normal') {
        this.PropertyInfo.topType = 'normal';
      } else if (this.propertyInfo.topType == 1 || this.propertyInfo.topType == 'goldTop') {
        this.PropertyInfo.topType = 'goldTop';
      } else {
        this.PropertyInfo.topType = 'normal';
      }
      /*复制楼盘如果是精选盘 默认定位到标准盘*/
      if (this.mode == 'copy' || this.mode == 'renewal' || this.mode == 'paynow') {
        if (this.propertyInfo.topType == 1) {
          this.PropertyInfo.topType = 0;
          this.normal();
        }
      }
      // 判断是否需要获取价格信息
      if (JSON.stringify(this.basePrice) == '[]') {
        this.SearchPropertyPriceSet();
      } else {
        this.standard = this.basePrice[0];
        this.Super = this.basePrice[1];
        this.Verified = this.basePrice[2];
      }
    },
    payMethods(payText) {
      this.setType(this.propertyInfo.rentalType); // 存储当前租售类型
      if (this.payway == 1) {
        this.$router.push({ name: 'pay', query: { orderid: this.orderID, type: 'paypal', source: 'post', fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
      }
      if (this.payway == 2) {
        this.CoinPay(payText);
      }
      if (this.payway == 3) {
        this.$router.push({ name: 'pay', query: { orderid: this.orderID, type: 'transfer', source: 'post', fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
      }
    },
    payNow() {
      this.payMethods(lang.payDone);
    },
    postRule(type) {
      if (this.PropertyInfo.topType == 'goldTop') {
        if (!this.propertyInfo.images || this.propertyInfo.images.length == 0) {
          return this.$toast(this.lang.topOne);
        }
      }
      this.SubmitVerif() ? (this.confrimTypeDialog = true) : '';
    },
    AddProperty() {
      this.Buttondisable = true;
      this.setProperty(this.PropertyInfo);
      this.postInfo = { ...this.propertyInfo };
      if (!this.postInfo.estateName || !this.postInfo.gscopeCode) {
        return this.failed();
      }
      try {
        post.dataFormat(this);
      } catch (error) {
        this.failed();
      }
      if (this.mode == 'post') {
        var data = {
          ...this.postInfo,
          propertyUserInfo: [{ ...this.propertyUserInfo }]
        };
      } else {
        var data = {
          ...this.postInfo,
          propertyUserInfo: [{ ...this.propertyUserInfo, userID: this.propertyInfo.userID }]
        };
      }
      // data.IsShowTel =ture;
      this.axios
        .post(this.pub.getApi().AddProperty, data)
        .then(res => {
          if (res.data.code === 0) {
            this.propertyID = res.data.result;
            this.getOrder(); // 2. 获取订单编号
            this.setProperty({ propertyID: res.data.result });
          } else {
            this.failed();
          }
        })
        .catch(item => {
          this.failed();
        });
    },
    edit() {
      if (this.PropertyInfo.topType == 'goldTop') {
        if (!this.propertyInfo.images || this.propertyInfo.images.length == 0) {
          return this.$toast(this.lang.topOne);
        }
      }
      this.Buttondisable = true;
      this.postInfo = { ...this.propertyInfo };
      if (!this.postInfo.estateName || !this.postInfo.gscopeCode) {
        return this.failed();
      }
      try {
        post.dataFormat(this);
      } catch (error) {
        this.failed();
      }
      const data = {
        ...this.postInfo,
        propertyUserInfo: [{ ...this.propertyUserInfo, userID: this.propertyInfo.userID }]
      };
      if (!data.phaseWithCulture) {
        data.phase = '';
        data.phaseEn = '';
        data.phaseZH = '';
        data['phaseWithCulture'] = '';
        data.parentEstateID > 0 ? data.estateID = data.parentEstateID : data.estateID = data.estateID;
      }
      // data.propertyUserInfo.IsShowTel =ture;
      this.axios
        .post(this.pub.getApi().UpdateProperty, data)
        .then(res => {
          if (res.data.code === 0) {
            Toast.success(lang.updateSuccess);
          } else {
            Toast.fail(lang.noChance);
          }
          setTimeout(item => {
            this.$router.push({ name: 'editProperties', query: { fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
          }, 500);
        })
        .catch(item => {
          this.failed();
        });
    },
    SubmitVerif() {
      if (!this.agreeRule) {
        this.$notify(this.lang.agreeClause);
        return;
      }
      if (!this.submitInfo) {
        this.$notify(this.lang.paywayRequ);
        return;
      }
      if (
        (!this.lastVerify && (this.PropertyInfo.isVerify && this.PropertyInfo.verifyImage == undefined)) ||
        (this.PropertyInfo.isVerify && this.PropertyInfo.verifyImage && this.PropertyInfo.verifyImage.length == 0)
      ) {
        this.$notify(lang.addRequ);
        return;
      }
      return true;
    },
    // 1.创建订单
    AddLight(way) {
      if (
        (!this.lastVerify && (this.PropertyInfo.isVerify && this.PropertyInfo.verifyImage == undefined)) ||
        (this.PropertyInfo.isVerify && this.PropertyInfo.verifyImage && this.PropertyInfo.verifyImage.length == 0)
      ) {
        this.$notify(lang.addRequ);
        return;
      }
      this.axios
        .post(this.pub.getApi().CreatePropertyOrder, {
          propertyId: this.$route.query.id,
          topType: this.PropertyInfo.topType,
          isVerify: this.PropertyInfo.isVerify,
          verifyImage: this.PropertyInfo.verifyImage
        })
        .then(res => {
          if (res.data.code === 0 && res.data.result) {
            this.orderID = res.data.result;
            if (way == 'create') {
              return this.getOrder();
            }
            this.payMethods(lang.payAdd);
          } else if (res.data.code == 1208) {
            Toast.setDefaultOptions({ className: 'center' });
            this.$toast(this.lang.maxRenewal);
          }
        })
        .catch(err => {
          this.orderError();
        });
    },
    // 获取订单id
    getOrder() {
      this.axios
        .post(this.pub.getApi().SearchOrderRecord, {
          sourceID: this.propertyID ? this.propertyID : this.propertyInfo.propertyId,
          sourceType: 'property',
          orderStatus: 'notPaid',
          pageIndex: 1,
          pageCount: 10
        })
        .then(result => {
          if (result.data.code === 0 && result.data.result) {
            /**放盘查询订单如果为空，创建一个订单 在支付*/
            if (result.data.result.data.length == 0) {
              return this.AddLight('create');
            }
            this.payInfo = result.data.result.data[0];
            this.orderID = this.payInfo.orderID;
            if (this.$route.query.type == 2) {
              this.payMethods(lang.payDone);
            }
            if (this.$route.query.type == 1) {
              this.topTitle = post.getTitle(this, this.lang);
              if (this.PropertyInfo.isVerify) {
                if (this.payInfo.money !== this.basePrice[this.PropertyInfo.topType === 'normal' ? 0 : 1].discountPrice + this.Verified.discountPrice) {
                  this.priceHidden = false;
                }
              } else {
                if (this.payInfo.money !== this.basePrice[this.PropertyInfo.topType === 'normal' ? 0 : 1].discountPrice) {
                  this.priceHidden = false;
                }
              }
            } else {
              this.payMethods(lang.payDone);
            }
          }
        })
        .catch(err => {
          this.orderError();
        });
    },
    // 屋币付款
    CoinPay(text) {
      this.axios
        .post(this.pub.getApi().PropertyCoinPaymentOrder, {
          orderId: this.orderID
        })
        .then(result => {
          // 屋币不足
          if (result.data.code == 1707) {
            return Dialog.confirm({
              title: lang.noGold,
              message: lang.noGoldText,
              confirmButtonText: lang.addGold,
              cancelButtonText: lang.cancel
            })
              .then(() => {
                this.$router.push({ name: 'storedValueMoney', query: { from: 'post', fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
              })
              .catch(() => {
                this.$router.push({ name: 'editProperties', query: { fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
              });
          }
          // code17开头提示 状态不正确
          if (String(result.data.code).startsWith('17')) {
            return this.orderError();
          }
          if (result.data.code === 0 && result.data.result) {
            Dialog.alert({
              title: lang.thanks,
              message: text,
              confirmButtonText: lang.confirm,
              cancelButtonText: lang.cancel
            }).then(() => {
              setTimeout(() => {
                this.$router.push({ name: 'editProperties', query: { fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
              }, 500);
            });
          }
        });
    },
    normal() {
      this.PropertyInfo.topType = 'normal';
    },
    gold() {
      this.PropertyInfo.topType = 'goldTop';
    },
    prev() {
      if (this.mode == 'renewal' || this.mode == 'paynow') {
        this.$router.push(`/editProDetail/${this.$route.query.id}/`);
      } else {
        this.setProperty({
          ...this.PropertyInfo,
          agreeRule: this.agreeRule,
          payway: this.payway
        });
        this.stepChange(5);
        this.$router.push('/post/step5/' + this.query);
      }
    },
    paySuccess(text) {
      Dialog.alert({
        title: lang.thanks,
        message: text,
        confirmButtonText: lang.confirm,
        cancelButtonText: lang.cancel
      }).then(() => {
        this.$router.push({ name: 'editProperties', query: { fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
      });
    },
    orderError() {
      Dialog.alert({
        title: lang.tip,
        message: lang.tipStatus,
        confirmButtonText: lang.confirm
      }).then(() => {
        this.$router.push({ name: 'editProperties', query: { fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
      });
    },
    // 操作失败
    failed() {
      Toast.fail(lang.noChance);
      setTimeout(item => {
        this.$router.push({ name: 'editProperties', query: { fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
      }, 500);
    }
  },
  computed: {
    ...mapState(['propertyInfo', 'sign', 'propertyUserInfo', 'basePrice']),
    submitInfo() {
      // 當勾選了同意放盤守則、選擇了付款方式、放盤方案后高亮可點擊
      if (this.agreeRule && this.payway && this.PropertyInfo.topType !== '') {
        return true;
      }
      return false;
    },
    NorlMoeny() {
      if (this.PropertyInfo.isVerify && !this.lastVerify) {
        return this.standard.discountPrice + this.Verified.discountPrice;
      }
      return this.standard.discountPrice;
    },
    GoldMoeny() {
      if (this.PropertyInfo.isVerify && !this.lastVerify) {
        return this.Super.discountPrice + this.Verified.discountPrice;
      }
      return this.Super.discountPrice;
    }
  },
  beforeDestroy() {
    this.setProperty({
      ...this.PropertyInfo,
      agreeRule: this.agreeRule,
      payway: this.payway,
      lastVerify: this.lastVerify
    });
  },
  components: {
    [Dialog.name]: Dialog,
    [Toast.name]: Toast
  },
  metaInfo() {
    return {
      title: this.topTitle
    };
  }
};
</script>

<style lang="scss" scoped>
@import url('../../../common/css/base.css');

/deep/ .van-dialog__header {
  color: #000;
}
.van-nav-bar {
  border-bottom: 1px solid #e3e4e6;
  background-color: #fafbfc;
}
.van-nav-bar__title {
  font-size: 17px;
  font-weight: 600;
}
.van-nav-bar__text {
  color: #333;
}
.van-nav-bar .van-icon {
  font-size: 25px;
  color: black;
}
.spacing {
  margin-top: 17px;
}
.post {
  padding-bottom: 120px;
}
.choose {
  height: 100%;
}
.bottom {
  border-bottom: 1px solid #efefef;
}
.edit {
  font-size: 15px;
  color: #0076ff;
}
.prices {
  background: #0054a6;
  border-radius: 2px;
  display: inline-block;
  padding: 0 5px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  color: #fff;
}
.cell {
  background-color: #fff;
  font-size: 15px;
  color: #333333;
  padding: 10px 15px;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  a {
    color: #3484fc;
  }
  .label {
    font-size: 12px;
    color: #999999;
    width: 90%;
    line-height: 25px;
    h4 {
      font-size: 17px;
      color: #333333;
      font-weight: 600;
    }
    h5 {
      font-size: 15px;
      color: #333333;
    }
  }
  .btn {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #ccc;
    display: inline-block;
    position: relative;
  }
  .checked {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    display: inline-block;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    background: #ed1c24;
    transform: translate(-50%, -50%);
  }
}
.disable {
  background-color: rgb(235, 147, 147) !important;
}
.submit {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 64px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #031932;
  color: #fff;
  z-index: 999;
  span {
    font-size: 10px;
    color: #b2b2b2;
    letter-spacing: 0.12px;
  }
  p {
    font-size: 22px;
    color: #ffffff;
  }

  button {
    width: 187px;
    height: 44px;
    border: 0;
    color: #fff;
    font-size: 15px;
    text-align: center;
    border-radius: 5px;
    background-color: #ccc;
  }
}
.red {
  background-color: #e80f2c !important;
}
.confirmType {
  margin: 20px 0 20px 0;
  text-align: center;
  font-size: 15px;
  color: #333;
  line-height: 30px;
}
.center {
  text-align: center !important;
}
</style>
